<template>
  <div class="select">
    <p class="label label-large" :class="{ 'label--is-disabled': disabled }">
      {{ label }}
    </p>
    <div class="combo-box" @click="toggleDropdown" :class="{ 'combo-box--is-disabled': disabled }">
      <div class="dropdown-selected" :aria-expanded="dropdownShown">
        <div class="dropdown-selected__pane">
          <div class="dropdown-selected__text">
            {{ selection }}
          </div>
          <i
            aria-hidden="true"
            class="dropdown-selected__item-icon icon-chevron-down"
            :style="{
              transform: `rotate(${dropdownShown ? '180deg' : '360deg'})`,
            }"
          ></i>
        </div>
      </div>
    </div>

    <div class="dropdown-options--is-selector dropdown-options" v-if="dropdownShown">
      <div class="dropdown-options__pane">
        <div class="dropdown-options-group">
          <div
            class="dropdown-option"
            :class="{ 'dropdown-option--is-selected': option.selected }"
            v-for="option in options"
            :key="option.value"
            @click="selectOption(option.value)"
          >
            <div class="dropdown-option__pane">
              <div class="dropdown-option__name">{{ option.label }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: [String],
    options: [Array],
    disabled: [Boolean],
  },
  data() {
    return {
      dropdownShown: false,
      selection: '',
    };
  },

  mounted() {
    this.selection = this.getSelectedValue();
  },
  methods: {
    getSelectedValue() {
      return this.options.filter((option) => option.selected)[0].label;
    },

    toggleDropdown() {
      if (this.disabled) {
        return false;
      }

      this.dropdownShown = !this.dropdownShown;
    },

    selectOption(value) {
      this.options.find((option) => option.selected).selected = false;
      this.options.find((option) => option.value === value).selected = true;
      this.selection = this.getSelectedValue();
      this.toggleDropdown();

      this.$emit('selected', value);
      this.$emit('resize', value);
    },
  },
};
</script>

<style scoped>
.select {
  position: relative;
}

.dropdown-options__pane {
  max-height: initial;
}

.dropdown-options {
  position: absolute;
  top: 70px;
  width: 300px;
}

.label {
  margin: 0 0 0.5rem 0;
}

.label--is-disabled {
  opacity: 0.3;
}
</style>
